import type { ZoneResult } from '../types/funnel';

/**
 * PRELIMINARY ZIP screen only. The approved Tampa dispatch center and 50-mile rule
 * are not yet configured, so this never qualifies a job for live checkout.
 * Production must geocode both full addresses server-side and evaluate radius
 * plus road distance/time separately.
 */
const LIKELY_IN = ['335', '336', '337'];
const EDGE = ['338', '342', '346'];

export type ZipScreen = 'in' | 'edge' | 'out' | 'invalid';

export function screenZip(zip: string): ZipScreen {
  if (!/^\d{5}$/.test(zip)) return 'invalid';
  const prefix = zip.slice(0, 3);
  if (LIKELY_IN.includes(prefix)) return 'in';
  if (EDGE.includes(prefix)) return 'edge';
  return 'out';
}

export function screenRoute(originZip: string, destZip: string): ZoneResult {
  const a = screenZip(originZip);
  const b = screenZip(destZip);
  if (a === 'invalid' || b === 'invalid') return 'incomplete';
  if (a === 'out' || b === 'out') return 'outside';
  if (a === 'edge' || b === 'edge') return 'review';
  return 'eligible_prelim';
}
